/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_F1 as F1,
  rec_JSXRuntime as JSXRuntime,
  rec_L1 as L1,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorHora as SelectorHora,
  rec_kr as kr,
} from "../../runtime/index.jsx";
export function PreguntaActa(e) {
  let t = (0, ReactCompiler.c)(48),
    { campo: n, valor: r, onChange: i, sinTitulo: a } = e,
    o = a !== void 0 && a,
    s;
  t[0] !== n.etiqueta || t[1] !== n.obligatorio || t[2] !== o
    ? ((s = !o && (
        <span
          className={`block text-sm text-(--text-h)`}
          children={[n.etiqueta, n.obligatorio ? ` *` : ``]}
        />
      )),
      (t[0] = n.etiqueta),
      (t[1] = n.obligatorio),
      (t[2] = o),
      (t[3] = s))
    : (s = t[3]);
  let c = s,
    l = (n.opciones?.length ?? 0) > 3;
  if (n.tipo === `UNICA` || n.tipo === `MULTIPLE`) {
    let e = n.etiqueta,
      a = l
        ? `grid grid-cols-2 gap-1.5 sm:grid-cols-3 [&>button]:text-left`
        : `flex flex-wrap gap-1`,
      o;
    if (
      t[4] !== n.excluyentes ||
      t[5] !== n.opciones ||
      t[6] !== n.tipo ||
      t[7] !== i ||
      t[8] !== r
    ) {
      let e;
      (t[10] !== n.excluyentes || t[11] !== n.tipo || t[12] !== i || t[13] !== r
        ? ((e = (e) => {
            let t = n.tipo === `MULTIPLE` ? (r || []).includes(e) : r === e;
            return (
              <button
                key={e}
                type={`button`}
                aria-pressed={t}
                className={`${L1} flex-1 ${t ? `animar-pop border-(--accent) bg-(--accent) text-(--accent-fg) font-semibold shadow-sm` : `border-(--border) bg-(--bg) text-(--text)`}`}
                onClick={() =>
                  i(
                    n.tipo === `MULTIPLE`
                      ? t
                        ? r.filter((t) => t !== e)
                        : n.excluyentes?.includes(e)
                          ? [e]
                          : [
                              ...(r || []).filter(
                                (e) => !n.excluyentes?.includes(e),
                              ),
                              e,
                            ]
                      : e,
                  )
                }
                children={[
                  t &&
                    (0, JSXRuntime.jsx)(kr, {
                      className: `mr-2 inline h-4 w-4`,
                    }),
                  e,
                ]}
              />
            );
          }),
          (t[10] = n.excluyentes),
          (t[11] = n.tipo),
          (t[12] = i),
          (t[13] = r),
          (t[14] = e))
        : (e = t[14]),
        (o = n.opciones.map(e)),
        (t[4] = n.excluyentes),
        (t[5] = n.opciones),
        (t[6] = n.tipo),
        (t[7] = i),
        (t[8] = r),
        (t[9] = o));
    } else o = t[9];
    let s;
    t[15] !== a || t[16] !== o
      ? ((s = <div className={a} children={o} />),
        (t[15] = a),
        (t[16] = o),
        (t[17] = s))
      : (s = t[17]);
    let u;
    return (
      t[18] !== n.etiqueta || t[19] !== s || t[20] !== c
        ? ((u = (
            <div
              role={`group`}
              aria-label={e}
              className={`min-w-0 space-y-2`}
              children={[c, s]}
            />
          )),
          (t[18] = n.etiqueta),
          (t[19] = s),
          (t[20] = c),
          (t[21] = u))
        : (u = t[21]),
      u
    );
  }
  if (n.tipo === `FECHA`) {
    let e = r || ``,
      n;
    t[22] !== i || t[23] !== e
      ? ((n = (
          <SelectorFecha
            className={`[&>button]:min-h-11`}
            value={e}
            onChange={i}
          />
        )),
        (t[22] = i),
        (t[23] = e),
        (t[24] = n))
      : (n = t[24]);
    let a;
    return (
      t[25] !== n || t[26] !== c
        ? ((a = <div className={`space-y-1`} children={[c, n]} />),
          (t[25] = n),
          (t[26] = c),
          (t[27] = a))
        : (a = t[27]),
      a
    );
  }
  if (n.tipo === `HORA`) {
    let e = r || ``,
      a;
    t[28] !== n.etiqueta || t[29] !== i || t[30] !== e
      ? ((a = <SelectorHora aria-label={n.etiqueta} value={e} onChange={i} />),
        (t[28] = n.etiqueta),
        (t[29] = i),
        (t[30] = e),
        (t[31] = a))
      : (a = t[31]);
    let o;
    return (
      t[32] !== a || t[33] !== c
        ? ((o = <div className={`space-y-1`} children={[c, a]} />),
          (t[32] = a),
          (t[33] = c),
          (t[34] = o))
        : (o = t[34]),
      o
    );
  }
  let u = n.tipo === `NUMERO` ? `number` : `text`,
    d = r ?? ``,
    f;
  t[35] !== n.tipo || t[36] !== i
    ? ((f = (e) =>
        i(n.tipo === `TEXTO` ? e.target.value.toUpperCase() : e.target.value)),
      (t[35] = n.tipo),
      (t[36] = i),
      (t[37] = f))
    : (f = t[37]);
  let p;
  t[38] !== n.etiqueta ||
  t[39] !== n.max ||
  t[40] !== n.min ||
  t[41] !== u ||
  t[42] !== d ||
  t[43] !== f
    ? ((p = (
        <input
          aria-label={n.etiqueta}
          className={F1}
          type={u}
          min={n.min}
          max={n.max}
          maxLength={500}
          value={d}
          onChange={f}
        />
      )),
      (t[38] = n.etiqueta),
      (t[39] = n.max),
      (t[40] = n.min),
      (t[41] = u),
      (t[42] = d),
      (t[43] = f),
      (t[44] = p))
    : (p = t[44]);
  let m;
  return (
    t[45] !== p || t[46] !== c
      ? ((m = <label className={`block space-y-1`} children={[c, p]} />),
        (t[45] = p),
        (t[46] = c),
        (t[47] = m))
      : (m = t[47]),
    m
  );
}
